import axios from "axios";

const instance = axios.create({
  baseURL: process.env.API_URL || "https://nekrodruk.pl/api/api",
  imgURL: process.env.API_URL || "https://nekrodruk.pl/api/uploads",
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("token"); // Usuń nieprawidłowy token
      window.location.href = "/login"; // Przekieruj na stronę logowania
    }
    return Promise.reject(error);
  },
);

export default instance;
